const PERSON = 'P'
const COMPANY = 'C'

export default {
  PERSON,
  COMPANY,
}
